if (!customElements.get('product-form')) {
	customElements.define('product-form', class AddToCart extends HTMLElement {
		constructor() {
			super();

			this.form = this.querySelector('form[action$="/cart/add"]');
			this.productIdInput = this.form?.querySelector('[name=id]');
			this.quantityInput = this.form?.querySelector('[name="count"]');

			this.btnAdd = this.querySelector('.count-inc');
			this.btnDec = this.querySelector('.count-dec');
			this.btnDel = this.querySelector('.count-del');

			if (this.btnAdd) this.btnAdd.addEventListener('click', this.increaseQuantity.bind(this));
			if (this.btnDec) this.btnDec.addEventListener('click', this.decreaseQuantity.bind(this));
			if (this.btnDel) this.btnDel.addEventListener('click', this.deleteItem.bind(this));

			this.addButtons = this.querySelectorAll('button[name="add"]');

			if (this.form && this.productIdInput) {
				this.productIdInput.disabled = false;
				this.form.addEventListener('submit', this.formSubmit.bind(this));
			}
		}
		setLoadingState(isLoading) {
			[this.btnAdd, this.btnDec, this.btnDel].forEach(btn => {
				if (btn) btn.disabled = isLoading;
			});
			if (this.addButtons?.length) {
				this.addButtons.forEach(btn => {
					btn.disabled = isLoading;
				});
			}
			if (this.quantityInput) this.quantityInput.disabled = isLoading;
			this.classList.toggle('is-loading', isLoading);
		}
		async formSubmit(evt) {
			evt.preventDefault();
			this.setLoadingState(true);

			const config = {
				...fetchConfig('javascript'),
				body: new FormData(this.form)
			};
			config.headers['X-Requested-With'] = 'XMLHttpRequest';
			delete config.headers['Content-Type'];

			try {
				const response = await fetch(routes.cart_add_url, config);
				const data = await response.json();

				if (!data.status) {
					this.success();
				}
			} finally {
				this.setLoadingState(false);
			}
		}

		success() {
			// this.openCartPopup();
			updateCartPopup(true);
		}

		openCartPopup() {
			const cartPopup = document.getElementById('cart-popup');
			const overflow = document.querySelector('.cart-overflow');
			const body = document.body;

			if (cartPopup) {
				cartPopup.classList.add('show');
			}

			if (overflow) {
				overflow.classList.add('show');
			}
			body.classList.add('no-scroll');
		}
		async updateCart(newQty) {
			const variantId = this.productIdInput?.value;
			if (!variantId) return;
			this.setLoadingState(true);

			const body = {
				id: variantId,
				quantity: newQty
			};

			try {
				const response = await fetch('/cart/change.js', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify(body)
				});

				const cart = await response.json();

				updateCartPopup(true);
				// this.openCartPopup();

				return cart;
			} finally {
				this.setLoadingState(false);
			}
		}

		async increaseQuantity(event) {
			event.preventDefault();
			let value = parseInt(this.quantityInput.value.replace(/\D/g, '')) || 1;
			value++;

			await this.updateCart(value);
		}
		async decreaseQuantity(event) {
			event.preventDefault();
			let value = parseInt(this.quantityInput.value.replace(/\D/g, '')) || 1;

			if (value <= 1) return;
			value--;

			await this.updateCart(value);
		}

		async deleteItem(event){
			event.preventDefault();

			this.quantityInput.value = 'x1';
			await this.updateCart(0);
		}
	});
}

